import React from 'react';
import ApplyNowButton from '../ApplyNowButton';
import './styles.scss';
import twoTreesLogo from '../../images/logo-two-line.jpg';
import fairHousingLogo from '../../images/logo-fair-housing-thinned.png';
import instagramIcon from '../../images/icon-instagram.png';
import facebookIcon from '../../images/icon-facebook.svg';

/* We used to have an email link in the footer, and would log the user clicking
on that link before they were redirected to the mailto. Client killed the email
link all together, though, so that code's gone now, but logged in git history. */

// small change for build

const component = ({
  openContactModal,
  openTermsAndConditionsModal,
  openAccessibilityModal,
}) => {
  const handleTermsClick = (e) => {
    e.preventDefault();
    openTermsAndConditionsModal();
  };
  const acceptedKey = 'cookiesAccepted';
  const declinedKey = 'cookiesDeclined';
  const acceptedExpiration = 'cookiesAcceptedExpiration';
  const declinedExpiration = 'cookiesDeclinedExpiration';

  const getLocalStorageCookieDate = (key) => {
    const expirationStr = localStorage.getItem(key);

    if (!expirationStr) {
      return null;
    }

    const expirationDate = new Date(expirationStr);
    if (isNaN(expirationDate.getTime())) {
      return null;
    }

    return expirationDate;
  };
  const deleteFromLocalStorage = (key) => {
    localStorage.removeItem(key);
  };
  const enableGoogleConsent = () => {
    if (window.gtag) {
      window.gtag('consent', 'update', {
        ad_storage: 'granted',
        ad_user_data: 'granted',
        ad_personalization: 'granted',
        analytics_storage: 'granted',
      });
    }
  };
  const disableGoogleConsent = () => {
    if (window.gtag) {
      window.gtag('consent', 'update', {
        ad_storage: 'granted',
        ad_user_data: 'granted',
        ad_personalization: 'granted',
        analytics_storage: 'granted',
      });
    }
  };

  const setCookieAccepted = () => {
    const expiration = new Date();
    expiration.setDate(expiration.getDate() + 30);
    localStorage.setItem(acceptedKey, true);
    localStorage.setItem(acceptedExpiration, expiration.toISOString());
    deleteFromLocalStorage(declinedKey);
    deleteFromLocalStorage(declinedExpiration);
  };
  const setCookieDeclined = () => {
    const expiration = new Date();
    expiration.setDate(expiration.getDate() + 30);
    localStorage.setItem(declinedKey, true);
    localStorage.setItem(declinedExpiration, expiration.toISOString());
    deleteFromLocalStorage(acceptedKey);
    deleteFromLocalStorage(acceptedExpiration);
  };
  const hideCookieBanner = () => {
    // Hide the cookie banner by adding a 'hidden' class
    const cookieBanner = document && document.getElementById('cookie-banner');

    if (cookieBanner) {
      cookieBanner.classList.add('hidden');
    }
  };
  const handleCookieAccept = () => {
    enableGoogleConsent();
    setCookieAccepted();
    hideCookieBanner();
  };
  const handleCookieDecline = () => {
    disableGoogleConsent();
    setCookieDeclined();
    hideCookieBanner();
  };

  if (typeof window !== 'undefined') {
    const sessionCookie =
      localStorage.getItem(acceptedKey) || localStorage.getItem(declinedKey);
    const acceptedExpiration = getLocalStorageCookieDate(
      'cookiesAcceptedExpiration'
    );
    const declinedExpiration = getLocalStorageCookieDate(
      'cookiesDeclinedExpiration'
    );

    const expirationDate = acceptedExpiration || declinedExpiration;
    const now = new Date();

    document &&
      document.addEventListener('DOMContentLoaded', function () {
        if (sessionCookie && expirationDate >= now) {
          hideCookieBanner();
        }
      });
  }

  return (
    <div className="footer">
      <div className="footer__list_wrapper">
        <ul className="footer__info-section footer__info-section--building-info">
          <li className={footerItemClassName('logo', 'two-trees-logo')}>
            <a href="https://www.twotreesny.com" target="_blank">
              <img
                src={twoTreesLogo}
                className="footer__two-trees-logo"
                alt="Two Trees Logo"
              />
            </a>
          </li>
          <li className={footerItemClassName()}>
            300 Ashland Place | Brooklyn, NY 11217
          </li>
          <li
            className={footerItemClassName('last', 'logo', 'fair-housing-logo')}
          >
            <img
              src={fairHousingLogo}
              className="footer__fair-housing-logo"
              alt="Equal Housing Opportunity"
            />
          </li>
          <li className={footerItemClassName('')}>
            <a
              className="footer__item--privacy"
              tabIndex="0"
              onClick={(e) => {
                handleTermsClick(e);
              }}
              onKeyPress={(e) => {
                handleTermsClick(e);
              }}
            >
              Privacy Policy
            </a>
            <a
              className="footer__item--accessibility"
              tabIndex="0"
              onClick={(e) => {
                e.preventDefault();
                openAccessibilityModal();
              }}
              onKeyPress={(e) => {
                e.preventDefault();
                openAccessibilityModal();
              }}
            >
              Accessibility
            </a>
            <a
              className="footer__item--fair-housing"
              target="_blank"
              href="https://assets.ctfassets.net/hy1449x19ffb/6NUFUYpeIK4EMGXXGQAbQ2/12b1241c555117da579e8c0bb045b885/fairhousingnotice_new.pdf"
            >
              Fair Housing
            </a>
          </li>
        </ul>
        <ul className="footer__info-section footer__info-section--cta-links">
          <li className={footerItemClassName('logo')}>
            <a
              href="https://www.facebook.com/300Ashland"
              target="_blank"
              aria-label="300 Ashland Facebook"
            >
              <img
                src={facebookIcon}
                alt="300 Ashland Facebook"
                className="footer__facebook-logo"
              />
            </a>
          </li>
          <li className={footerItemClassName('logo')}>
            <a
              href="https://www.instagram.com/300ashland"
              target="_blank"
              aria-label="300 Ashland Instagram"
            >
              <img
                src={instagramIcon}
                alt="300 Ashland Instagram"
                className="footer__instagram-logo"
              />
            </a>
          </li>

          <li className={footerItemClassName('button')}>
            <a
              className="button"
              role="button"
              tabIndex="0"
              onClick={(e) => {
                e.preventDefault();
                openContactModal();
              }}
              onKeyPress={(e) => {
                e.preventDefault();
                openContactModal();
              }}
            >
              Contact
            </a>
          </li>
          <li
            className={
              'footer__button-apply ' + footerItemClassName('button', 'last')
            }
          >
            <ApplyNowButton />
          </li>
        </ul>
      </div>

      <div className="footer__copyright">
        Copyright 2020 Two Trees Management Co., LLC. All Rights Reserved.
      </div>
      <div className="footer__brandingSectionContainer">
        <div>
          <h2 className="footer__brandingTitle">
            Two Trees Residential Properties
          </h2>
          <div className="footer__brandingSectionLinks">
            <div className="footer__brandingSection__linkSection">
              <span className="footer__brandingSection__linkSectionTitle">
                Dumbo
              </span>
              <div className="footer__brandingSection__links">
                <p>
                  <a
                    href="https://www.twotreesny.com/apartments/25-washington"
                    target="_blank"
                  >
                    25 Washington St
                  </a>
                  <span className="footer__divider">|</span>
                  <a
                    href="https://www.twotreesny.com/apartments/30-washington"
                    target="_blank"
                  >
                    30 Washington St
                  </a>
                </p>
                <p>
                  <a
                    href="https://www.twotreesny.com/apartments/60-water"
                    target="_blank"
                  >
                    60 Water St
                  </a>
                  <span className="footer__divider">|</span>
                  <a
                    href="https://www.twotreesny.com/apartments/65-washington"
                    target="_blank"
                  >
                    65 Washington St
                  </a>
                </p>
                <p>
                  <a
                    href="https://www.twotreesny.com/apartments/81-washington"
                    target="_blank"
                  >
                    81 Washington St
                  </a>
                  <span className="footer__divider">|</span>
                  <a
                    href="https://www.twotreesny.com/apartments/85-water"
                    target="_blank"
                  >
                    85 Water St
                  </a>
                </p>
                <p>
                  <a
                    href="https://www.twotreesny.com/apartments/66-water"
                    target="_blank"
                  >
                    66 Water St
                  </a>
                </p>
              </div>
            </div>
            <div className="footer__brandingSection__linkSection">
              <span className="footer__brandingSection__linkSectionTitle">
                Williamsburg
              </span>
              <div className="footer__brandingSection__links">
                <p>
                  <a
                    href="https://www.onedominosquare.com/residences/rentals"
                    target="_blank"
                  >
                    One Domino Square Rentals
                  </a>
                  <span className="footer__divider">|</span>
                </p>
                <p>
                  <a
                    href="https://www.onedominosquare.com/residences/condos"
                    target="_blank"
                  >
                    One Domino Square Condominiums
                  </a>
                </p>
                <p>
                  <a href="https://www.onesouthfirst.com/" target="_blank">
                    One South First
                  </a>
                  <span className="footer__divider">|</span>
                  <a href="https://www.325kent.com/" target="_blank">
                    325 Kent
                  </a>
                </p>
              </div>
              <span className="footer__brandingSection__linkSectionTitle">
                Downtown Brooklyn / Fort Greene
              </span>
              <div className="footer__brandingSection__links">
                <p>
                  <a
                    href="https://www.twotreesny.com/apartments/300-ashland"
                    target="_blank"
                  >
                    300 Ashland
                  </a>
                </p>
              </div>
            </div>
            <div className="footer__brandingSection__linkSection">
              <span className="footer__brandingSection__linkSectionTitle">
                Brooklyn Heights / Cobble Hill
              </span>
              <div className="footer__brandingSection__links">
                <p>
                  <a
                    href="https://www.twotreesny.com/apartments/125-court-street"
                    target="_blank"
                  >
                    125 Court St
                  </a>
                  <span className="footer__divider">|</span>
                  <a
                    href="https://www.twotreesny.com/apartments/110-livingston"
                    target="_blank"
                  >
                    110 Livingston St
                  </a>
                </p>
                <p>
                  <a
                    href="https://www.twotreesny.com/apartments/164-atlantic"
                    target="_blank"
                  >
                    164 Atlantic Ave
                  </a>
                  <span className="footer__divider">|</span>
                  <a
                    href="https://www.twotreesny.com/apartments/cobble-hill-mews"
                    target="_blank"
                  >
                    200 Atlantic Ave
                  </a>
                </p>
                <p>
                  <a
                    href="https://www.twotreesny.com/apartments/138-court-street"
                    target="_blank"
                  >
                    138 Court St
                  </a>
                </p>
              </div>
            </div>
            <div className="footer__brandingSection__linkSection">
              <span className="footer__brandingSection__linkSectionTitle">
                Hell's Kitchen
              </span>
              <div className="footer__brandingSection__links">
                <p>
                  <a href="https://www.mercedeshouseny.com/" target="_blank">
                    Mercedes House
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div>
          <h2 className="footer__brandingTitle">
            Two Trees Commercial Office Spaces
          </h2>
          <div className="footer__brandingSectionLinks">
            <div className="footer__brandingSection__linkSection">
              <span className="footer__brandingSection__linkSectionTitle">
                Dumbo
              </span>
              <div className="footer__brandingSection__links">
                <p>
                  <a
                    href="https://www.twotreesny.com/office-spaces/45-main-street"
                    target="_blank"
                  >
                    45 Main St
                  </a>
                  <span className="footer__divider">|</span>
                  <a
                    href="https://www.twotreesny.com/office-spaces/55-washington"
                    target="_blank"
                  >
                    55 Washington St
                  </a>
                </p>
                <p>
                  <a
                    href="https://www.twotreesny.com/office-spaces/20-jay-street"
                    target="_blank"
                  >
                    20 Jay St
                  </a>
                </p>
              </div>
            </div>
            <div className="footer__brandingSection__linkSection">
              <span className="footer__brandingSection__linkSectionTitle">
                Williamsburg
              </span>
              <div className="footer__brandingSection__links">
                <p>
                  <a href="https://www.tengrandstreet.com/" target="_blank">
                    Ten Grand Street
                  </a>
                </p>
                <p>
                  <a
                    href="https://www.therefineryatdomino.com/"
                    target="_blank"
                  >
                    The Refinery at Domino
                  </a>
                </p>
              </div>
            </div>

            <div className="footer__brandingSection__linkSection">
              <span className="footer__brandingSection__linkSectionTitle">
                Flatiron
              </span>
              <div className="footer__brandingSection__links">
                <p>
                  <a
                    href="https://www.twotreesny.com/office-spaces/50-west-23rd-street"
                    target="_blank"
                  >
                    50 West 23rd St
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="cookie-banner" className="global-layout__cookie">
        <div className="cookie-wrapper" href="/availability">
          <div className="cookie-text">
            <p>
              We use technologies, such as cookies, to customize content and
              advertising, to provide social media features and to analyze
              traffic to the site. We also share information about your use of
              our site with our trusted social media, advertising and analytics
              partners.{' '}
              <a
                onClick={(e) => {
                  handleTermsClick(e);
                }}
                onKeyPress={(e) => {
                  handleTermsClick(e);
                }}
              >
                See Updated Cookie Notice.
              </a>
            </p>
          </div>
          <button
            onClick={() => handleCookieAccept()}
            className="cookie-button"
          >
            Accept
          </button>
          <button
            onClick={() => handleCookieDecline()}
            className="cookie-button"
          >
            Decline
          </button>
        </div>
      </div>
    </div>
  );
};

component.displayName = 'Footer';
export default component;

function footerItemClassName(...modifiers) {
  return modifiers.reduce(
    (className, modifier) => className + ' footer__item--' + modifier,
    'footer__item'
  );
}



// WEBPACK FOOTER //
// ./client/components/Footer/index.js